// src/hooks/useCustomization.ts
import { useCallback, useMemo, useEffect } from "react";
import { CardCustomization } from "../types/card.types";
import { debounce } from "../utils/helpers";
import { DEBOUNCE_DELAY } from "../constants/studio";

export const useCustomization = (
  setCustomization: React.Dispatch<
    React.SetStateAction<CardCustomization | null>
  >,
) => {
  const debouncedUpdate = useMemo(
    () =>
      debounce((updates: Partial<CardCustomization>) => {
        setCustomization((prev) => (prev ? { ...prev, ...updates } : null));
      }, DEBOUNCE_DELAY),
    [setCustomization],
  );

  useEffect(() => {
    return () => debouncedUpdate.cancel();
  }, [debouncedUpdate]);

  const updateCustomization = useCallback(
    (updates: Partial<CardCustomization>) => {
      setCustomization((prev) => {
        if (!prev) return null;
        return { ...prev, ...updates };
      });
      debouncedUpdate(updates);
    },
    [debouncedUpdate, setCustomization],
  );

  return {
    updateCustomization,
  };
};
